import { render, staticRenderFns } from "./log-history-detail-modal.vue?vue&type=template&id=6c188abe&scoped=true&"
import script from "./log-history-detail-modal.vue?vue&type=script&lang=js&"
export * from "./log-history-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c188abe",
  null
  
)

export default component.exports